import { useCallback, useState } from 'react'
import { readPerWindow, readPerWindowScoped, writePerWindow, writePerWindowScoped } from '@/features/load-hub/utils/perWindowStorage'
import { BOX_TRUCK_WORKSPACE_TTL_MS } from '../utils/boxTruckTabExpiration'

const STORAGE_KEY = 'box_truck_filters_collapsed'

/** Persists the compact-board preference without letting one open browser window change another. */
export const useBoxTruckFiltersCollapsed = (scopedOnly = false) => {
    const [collapsed, setCollapsedState] = useState(() => (scopedOnly ? readPerWindowScoped(STORAGE_KEY) : readPerWindow(STORAGE_KEY)) === 'true')

    const setCollapsed = useCallback(
        (next: boolean) => {
            setCollapsedState(next)
            const write = scopedOnly ? writePerWindowScoped : writePerWindow
            write(STORAGE_KEY, String(next), BOX_TRUCK_WORKSPACE_TTL_MS)
        },
        [scopedOnly]
    )

    return { collapsed, setCollapsed }
}
